<template>
  <div class="swiper-box">
    <el-carousel indicator-position="outside" arrow="never" height="20rem">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="swiper-wrap">
          <div
            class="swiper-item"
            v-for="(sitem, sindex) in item"
            :key="sindex"
            @click="$emit('toInfo', sitem.id)"
          >
            <div style="width: 18.125rem; height: 13.4375rem; overflow: hidden">
              <img :src="getImgUrl(sitem.thumb)" class="icon hvr-grow" alt="" />
            </div>
            <div class="title">{{ sitem.title }}</div>
            <div class="text">{{ sitem.describe || "" }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperList: [],
    };
  },
  mounted() {
    switch (this.indexNum) {
      case 1:
        this.swiperList = [
          {
            img: require("@/assets/case/com (4).png"),
            title: "山禾泉品牌设计",
            text: "品牌设计",
          },
          {
            img: require("@/assets/case/com (3).png"),
            title: "思芝谷教育品牌设计",
            text: "品牌设计",
          },
          {
            img: require("@/assets/case/com (2).png"),
            title: "乐讯品牌设计",
            text: "品牌设计",
          },
          {
            img: require("@/assets/case/com (1).png"),
            title: "联瑞科技品牌设计",
            text: "品牌设计",
          },
        ];
        break;
      case 2:
        this.swiperList = [
          {
            img: require("@/assets/case/sys (1).png"),
            title: "检察院 排位系统",
            text: "系统开发",
          },
          {
            img: require("@/assets/case/sys (2).png"),
            title: "环保局OA管理系统",
            text: "系统开发",
          },
        ];
        break;
    }
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
